import React from "react";
import { Modal } from "antd";

import history from "../../services/history";

export default function SuccessSignUp({
  isModalVisible,
  setIsModalVisible,
  type,
  errorMessage,
}) {
  return (
    <Modal
      title={type === "success" ? "Cadastro finalizado" : "Falha ao cadastrar"}
      open={isModalVisible}
      onOk={() => {
        type !== "success" && setIsModalVisible(false);
      }}
      onCancel={() => {
        setIsModalVisible(false);
      }}
      style={{ textAlign: "center" }}
      bodyStyle={{ textAlign: "left" }}
      width={600}
      footer={null}
    >
      <div className="__billets-confirm-box-info">
        <div className="__billets-confirm-box-billet">
          <div className="__billets-item">
            {type === "success" && (
              <p>
                Seu cadastro foi realizado com sucesso, estamos analisando seus
                dados, em até alguns minutos você receberá a confirmação no seu
                email.
              </p>
            )}
            {type === "error" && <p>{errorMessage}</p>}
          </div>
        </div>
      </div>
    </Modal>
  );
}
